module.exports = __webpack_public_path__ + "img/Icon_Contestacion_Remedio_Provicional_over.cf08254c.svg";